import React, { useState, useEffect } from 'react';
import api from '../api/api';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Buildings } from '@phosphor-icons/react';
import { toast } from 'sonner';

export const CenterInviteBanner = () => {
  const [invites, setInvites] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try {
      const r = await api.get('/api/center/invites/mine');
      setInvites(r.data.items || []);
    } catch { /* silent */ }
  };

  useEffect(() => { load(); }, []);

  const respond = async (invite, accept) => {
    setBusy(true);
    try {
      await api.post(`/api/center/invites/${invite.invite_id}/respond`, { accept });
      toast.success(accept ? 'Invito accettato: ora fai parte del Centro' : 'Invito rifiutato');
      if (accept) { window.location.href = '/internal'; return; }
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Errore');
    } finally { setBusy(false); }
  };

  if (invites.length === 0) return null;

  return (
    <div className="space-y-3 mb-6" data-testid="center-invite-banner">
      {invites.map((i) => (
        <Card key={i.invite_id} className="p-4 rounded-2xl border-primary/30 bg-[#F5FAFF]" data-testid={`my-invite-${i.invite_id}`}>
          <div className="flex items-start gap-3 flex-wrap">
            <Buildings size={22} className="text-primary mt-0.5" weight="duotone" />
            <div className="flex-1 min-w-[240px]">
              <div className="font-semibold text-sm mb-1">Invito da {i.center_name || 'un Centro'}</div>
              <p className="text-xs text-foreground/70">
                Se accetti, le richieste dei clienti arriveranno al Centro che te le assegnerà: il tuo
                profilo non comparirà più nelle ricerche dirette e i crediti resteranno a carico del Centro.
              </p>
            </div>
            <div className="flex gap-2">
              <Button size="sm" className="rounded-full h-8" disabled={busy} onClick={() => respond(i, true)} data-testid={`accept-invite-${i.invite_id}`}>
                Accetta
              </Button>
              <Button size="sm" variant="outline" className="rounded-full h-8" disabled={busy} onClick={() => respond(i, false)} data-testid={`decline-invite-${i.invite_id}`}>
                Rifiuta
              </Button>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default CenterInviteBanner;
